import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';
import { useFileUploadStore } from '@/store/fileUpload';


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
    modelValue: {},
    label: {},
    rules: {},
    readonly: { type: Boolean },
    icon: {},
    module: {},
    multiple: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const fileUploadStore = useFileUploadStore();

const internalFile = ref<File | null>(null);
const loading = ref(false);

const uploadFile = async () => {
  if (!internalFile.value || !props.module) return;

  loading.value = true;
  try {
    const url = await fileUploadStore.uploadFile(props.module, internalFile.value);
    emit('update:modelValue', url);
  } catch (e) {
    console.error('[FileUploader] Error al subir archivo:', e);
  } finally {
    loading.value = false;
  }
};

// Limpieza automática
watch(() => props.modelValue, val => {
  if (!val) internalFile.value = null;
});

const isUrl = (val: any): boolean => {
  return typeof val === 'string' && /^https?:\/\//.test(val);
};

const extractFileName = (url: string): string => {
  try {
    const parts = url.split('?')[0].split('/');
    return decodeURIComponent(parts[parts.length - 1]);
  } catch (e) {
    return 'archivo';
  }
};

const onDownloadClick = () => {
  if (props.modelValue && isUrl(props.modelValue)) {
    window.open(props.modelValue as string, '_blank');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_file_input, {
      modelValue: internalFile.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalFile).value = $event)),
      label: _ctx.modelValue && isUrl(_ctx.modelValue) ? extractFileName(_ctx.modelValue) : _ctx.label,
      disabled: loading.value,
      rules: _ctx.rules,
      accept: "*",
      density: "compact",
      clearable: "",
      "prepend-inner-icon": _ctx.modelValue && isUrl(_ctx.modelValue) ? 'mdi-download' : undefined,
      "onClick:prependInner": onDownloadClick,
      onChange: uploadFile
    }, null, 8, ["modelValue", "label", "disabled", "rules", "prepend-inner-icon"])
  ]))
}
}

})